import { getFilePath } from 'new/utils/FileUtil/getFilePath';
import { buildSelectedBucket } from 'new/utils/FileUtil/buildSelectedBucket';
import {
  getFilesAllowedToReingest,
  isReingestAllowed,
  mapFilesForReingestion,
} from 'new/utils/FileUtil/reingest';

/**
 * Used at DestinationSetup.js and SinkConfigureStep.tsx
 */
const isAllowedToUseCustomPrefixEditor = (selectedBucket: any, sinkConfig: any) => {
  return (
    selectedBucket?.path &&
    sinkConfig?.['ui.selected_file_mime_type'] !== 'application/vnd.google-apps.spreadsheet'
  );
};

export const FileUtil = {
  getFilePath,
  buildSelectedBucket,
  isReingestAllowed,
  mapFilesForReingestion,
  getFilesAllowedToReingest,
  isAllowedToUseCustomPrefixEditor,
};
